import { Injectable } from '@angular/core';
import { ResidentialService } from '../services/residential.service';

@Injectable()
export class GuaranteeResolver  {

  constructor(private resService: ResidentialService) {}

  resolve() {
    return this.resService.getFormData('rent-guarantee');
  }
}
